import type { InspectionPhotoDTO } from '../../data/LoadDTO';

export function isUsableImageUrl(value: string | null | undefined): boolean {
  return typeof value === 'string' && value.trim().length > 0;
}

export function isInspectionPhotoSynced(photo: {
  url: string;
  thumbnailUrl: string;
}): boolean {
  return isUsableImageUrl(photo.url) && isUsableImageUrl(photo.thumbnailUrl);
}

export interface InspectablePhotoUrls {
  url: string;
  thumbnailUrl: string;
}

export function isDefaultInspectionPhoto(photo: InspectionPhotoDTO): boolean {
  if (photo.default_image) {
    return true;
  }

  if (!isUsableImageUrl(photo.guid)) {
    return true;
  }

  if (
    typeof photo.is_vehicle_detected !== 'boolean' &&
    !isUsableImageUrl(photo.taken_at)
  ) {
    return true;
  }

  return false;
}

export function getInspectableUrlsFromVideo(video: {
  url: string;
  thumbnail_url: string;
}): InspectablePhotoUrls {
  return {
    url: video.url,
    thumbnailUrl: video.thumbnail_url,
  };
}

export function getInspectablePhotoSyncCounts(photos: InspectablePhotoUrls[]): {
  synced: number;
  total: number;
} {
  const total = photos.length;
  const synced = photos.filter((photo) =>
    isInspectionPhotoSynced(photo),
  ).length;
  return { synced, total };
}
